import settings from "../../../constants/settings";
import useFetchAndTrace from "../fetchWithTrace";
import { useState } from "react";
import { useCustomAlert } from "../alerts";

export default function useDeleteEmptyContainer(
  onUnload?: () => void,
  onError?: () => void,
) {
  const fetchAndTrace = useFetchAndTrace();
  const [loading, setLoading] = useState<boolean>(false);
  const customAlert = useCustomAlert();
  const unloadEmptyContainerHandler = async (response: Response) => {
    if (response.ok) {
      setLoading(false);
      onUnload?.();
    } else if (response.status === 400) {
      setLoading(false);
      const { detail } = (await response.json()) as { detail: string };
      customAlert(detail);
      onError?.();
    } else {
      throw new Error("Failed to delete container(s)");
    }
  };

  const errorHandler = () => {
    setLoading(false);
    customAlert("Failed to delete container(s)");
    onError?.();
  };

  const deleteEmptyContainer = (
    containerBarcode: string,
    shipmentIds: string[],
  ) => {
    setLoading(true);
    void fetchAndTrace(
      `${settings.api_url}/inventory/containers/unload-empty`,
      unloadEmptyContainerHandler,
      errorHandler,
      {
        body: JSON.stringify({
          container_barcode: containerBarcode,
          shipment_ids: shipmentIds,
        }),
        method: "PUT",
      },
    );
  };
  return { deleteEmptyContainer, deletingEmptyContainer: loading };
}
